import React from 'react';
import { formatValue, clearValue } from '../../utils';

export default class Remuneration extends React.Component {
    constructor(props) {
        super(props);

        this.initialState = {
            total: '',
            recurring: '',
            oneOff: '',
            errors: props.errors || {}
        };

        this.onChange = null;
        this.state = this.initialState;
    }

    static getDerivedStateFromProps(props, state) {
        return Object.assign({}, state, {
            errors: props.errors
        });
    }

    handleRawChange = (type, value) => {
        clearTimeout(this.onChange);

        const newState = Object.assign({},
            this.state,
            {
                [type]: value
            }
        );

        this.onChange = setTimeout(this.handleChange, 1000);
        this.setState(newState);
    }

    handleChange = () => {
        const { total, recurring, oneOff } = this.state;

        const newState = Object.assign({},
            this.state,
            {
                total: formatValue(total),
                recurring: formatValue(recurring),
                oneOff: formatValue(oneOff)
            }
        );

        const clearedState = Object.assign({},
            newState,
            {
                total: clearValue(newState.total),
                recurring: clearValue(newState.recurring),
                oneOff: clearValue(newState.oneOff)
            }
        );

        this.props.handleChange(clearedState);
        this.setState(newState);
    }

    render() {
        const { errors, total, recurring, oneOff } = this.state;

        return (
            <div className='row'>
                <div className='col-sm-12 col-md-6 col-xl-4'>
                    <div className={'pcb-input ' + (errors.total ? 'has-error' : '')}>
                        <label>
                            MONTHLY SALARY
                        </label>

                        <input
                            type='text'
                            placeholder='Type in your monthly salary (RM)'
                            value={total}
                            onChange={event =>
                                this.handleRawChange('total', event.target.value)
                            }
                        />
                    </div>
                </div>

                <div className='col-sm-12 col-md-6 col-xl-4'>
                    <div className='pcb-input'>
                        <label>
                            BONUS
                        </label>

                        <input
                            type='text'
                            placeholder='Type in your bonus (RM)'
                            value={oneOff}
                            onChange={event =>
                                this.handleRawChange('oneOff', event.target.value)
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }
}

/*
                <div className='col-sm-12 col-md-6 col-xl-4'>
                    <div className='pcb-input'>
                        <label>
                            MONTHLY REMUNERATION <i
                                className="fa fa-question-circle"
                                data-tip="Add additions that don't change on a monthly basis, e.g. a fixed allowance. See
                                    <a href='http://help.payrollpanda.my/18570-app-faq/209237-when-do-i-apply-payroll-items-as-recurring' target='_blank'>
                                        help
                                    </a> article for more info."
                            ></i>
                        </label>

                        <input
                            type='text'
                            placeholder='Type in your recurring additions (RM)'
                            value={recurring}
                            onChange={event =>
                                this.handleRawChange('recurring', event.target.value)
                            }
                        />
                    </div>
                </div>
                */


// WEBPACK FOOTER //
// ./src/components/Calculator/Remuneration.js